import { render, staticRenderFns } from "./module-info.vue?vue&type=template&id=5315f6f4&"
import script from "./module-info.vue?vue&type=script&lang=js&"
export * from "./module-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs-edu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5315f6f4')) {
      api.createRecord('5315f6f4', component.options)
    } else {
      api.reload('5315f6f4', component.options)
    }
    module.hot.accept("./module-info.vue?vue&type=template&id=5315f6f4&", function () {
      api.rerender('5315f6f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/module-info.vue"
export default component.exports